import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getBannerList = createAsyncThunk(
  "banner/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.banners +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
    return response.data;
  }
);

export const addBanner = createAsyncThunk(
  "banner/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.banners, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editBanner = createAsyncThunk(
  "banner/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.banners + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getBannerCount = async () =>{
  const response = await Client(API_METHOD.GET, url.banners)
  return response.data?.data?.item?.total_count;
}

export const getBanner = createAsyncThunk("banner/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.banners + `/${id}`);
  return response.data;
});

